


type AlertMapper = {
  high: number;
  very_high: number;
  moderate: number;
  low: number;
  "very low": number;
};

type Assessment = {
  name: string;
  value: number;
};

export type RawData = {
  displayDate: string;
  allAssessments: Assessment[];
};

const alertMapper: AlertMapper = {
  high: 4,
  very_high: 3,
  moderate: 2,
  low: 1,
  "very low": 0,
};

export function transformChartData(rawData: RawData[]) {
  return rawData.map((day) => {
    const aa = day.allAssessments.reduce((acc, assessment) => {
      const nestedLine = {
        [assessment.name]:
          alertMapper[
            assessment[
              assessment.name as unknown as keyof Assessment
            ] as keyof typeof alertMapper
          ],
      };

      Object.assign(acc, nestedLine);

      return acc;
    }, {});

    return {
      displayDate: day.displayDate,
      ...aa,
      allAssessments: day?.allAssessments,
    };
  });
}
